import { useIntl } from 'react-intl';

import { TerminalWorkflowType } from '../../../../api/terminals';
import ActionCard from '../../../../components/domain/ActionCard';
import { AllowedActionViewProps } from '../../../../components/domain/AllowedAction';
import useTerminal from '../../../../hooks/useTerminal';
import { isDelivery, isNSDelivery, isNSEmployee } from '../../../../services/contact/GlobalPermissions';
import { CollectWorkflow } from '../../../nike/CollectWorkflow';

type CollectActionProps = AllowedActionViewProps;

function CollectWorkflowAction(props: CollectActionProps) {
    const intl = useIntl();
    const terminal = useTerminal();
    //conditions
    if (terminal === null || props.contact === undefined) return undefined;
    if (
        !(
            // These define the ALLOWED cases
            (
                (terminal.workflow === TerminalWorkflowType.IMES_DEXIS_NIKE && !isDelivery(props.contact)) ||
                (terminal.workflow === TerminalWorkflowType.DELHAIZE && !isDelivery(props.contact)) ||
                isNSEmployee(props.contact) ||
                isNSDelivery(props.contact)
            )
        )
    )
        return undefined;

    const CollectWorkflowAction: ActionCard = {
        actionText: intl.formatMessage({
            id: 'workflow.nike.DashboardWorkflow.CollectItemsAction',
            description: 'This is the collect action on the Nike dashboard',
            defaultMessage: 'Collect item(s)',
        }),
        icon: <i className='bi bi-cart4 dashboard-action-icon' />,
        view: (
            <CollectWorkflow
                loggedInContact={props.contact}
                onHome={props.onHome}
                onInactivity={props.onInactivity}
                onLogout={props.onHome}
            />
        ),
    };
    return CollectWorkflowAction;
}

export default CollectWorkflowAction;
